module.exports = __webpack_public_path__ + "img/9788949123004.64fc6234.jpg";